<template>
	<div style="width:100% !important;height:1222px;">
		<b-card-group deck>
			<b-card bg-variant="dark" text-variant="primary">
				<!-- <b-img src="/content/images/Measures.png" fluid alt="Responsive image"></b-img> -->
				<b-card-text>
					<!-- With supporting text below as a natural lead-in to additional content. -->
					Coming Soon !
				</b-card-text>
				<!-- <b-button href="https://localhost:8094/Patient/1363/measures" variant="primary">Stars</b-button> -->
				<b-card-group deck>
					<!-- <GlucoseTrackerSTUB />
					<A1CTrackerSTUB />
					<WeightTrackerSTUB /> -->
				</b-card-group>
			</b-card>

			<!-- <div>
		<b-card title="Measures" header-text-variant="light" header-bg-variant="primary-green" class="overflow-hidden w-75" style="padding:0px 0px 0px 0px;">
			<b-img src="/content/images/Measures.png" fluid alt="Responsive image"></b-img>
			<template #header>
				<b-row class="justify-content-sm-start"></b-row>
			</template>
		</b-card>
			</div>-->

			<!-- <DashboardPageThree /> -->

			<!-- <div>fetchMyWorkDetails: {{fetchMyWorkDetails}} </div> -->
		</b-card-group>
	</div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, } from 'vue'

const AreIdsShown = ref(false)

onMounted(() =>
{
	// console.clear()
// console.log(' 		DISEASE MNGMT CONTAINER')
})

</script>


<!-- <script>
import GlucoseTrackerSTUB from '@/views/Dashboard/GlucoseTrackerSTUB.vue'
import A1CTrackerSTUB from '@/views/Dashboard/A1C_TrackerSTUB.vue'
import WeightTrackerSTUB from '@/views/Dashboard/WeightTrackerSTUB.vue'

import DashboardPageThree from '../../components/DashboardPageThree.vue'

export default {
	name: 'DiseaseMngtContainer',
	components: {
		GlucoseTrackerSTUB,
		A1CTrackerSTUB,
		WeightTrackerSTUB,
		DashboardPageThree,
	},
	data() {
		return {
			fetchMyWorkDetails,
		}
	},
	computed: {},
	methods: {},
	created() {
		// // console.log('temp ,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,')
	},
}
</script> -->


<style scoped>
.card {
	border: 3px solid transparent !important;
	/* padding: 15px; */
	border-radius: 5px;
	background-color: #39464344 !important;
	width: 100% !important;
}
.card-img,
.card-img-top,
.card-img-bottom {
	height: 222px;
	flex-shrink: 0;
	width: 100%;
}
</style>
